import { render, staticRenderFns } from "./GoodsCollection.vue?vue&type=template&id=756d68a4&scoped=true&"
import script from "./GoodsCollection.vue?vue&type=script&lang=js&"
export * from "./GoodsCollection.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCollection.vue?vue&type=style&index=0&id=756d68a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756d68a4",
  null
  
)

export default component.exports